import styled from 'styled-components';
import type { PropsWithChildren } from 'react';
import { colors, grid } from '@zopauk/react-components';
import { type TextLinkProps, TextLink } from '../TextLink';

type LinkWrapperProps = {
  condition: boolean;
} & PropsWithChildren &
  TextLinkProps;

const Wrapper = styled.div`
  position: relative;
  border: 1px solid ${colors.greyLight};
  border-radius: 8px;
  padding: 24px;
  background-color: ${colors.white};
  margin-bottom: 24px;
  transition: 0.3s ease transform;
  border-left: 10px solid ${colors.brandDecorative};

  .discovery & {
    border-left: 5px solid ${colors.actionPlain};
  }

  .closed & {
    background-color: ${colors.greyLightest};
    border-left-color: ${colors.greyDark};
  }

  &.has-icon {
    padding-right: 40px;

    @media screen and (min-width: ${grid.breakpoints.s}px) {
      padding-right: 80px;
    }

    &:hover {
      transform: scale(1.01);
    }
  }

  .chevron {
    position: absolute;
    right: 14px;
    width: 13px;
    height: 21px;
    top: 50%;
    transform: translateY(-50%);

    @media screen and (min-width: ${grid.breakpoints.s}px) {
      right: 38px;
    }
  }
`;

export const ConditionalLinkWrapper = ({ condition, children, ...rest }: LinkWrapperProps) =>
  condition ? (
    <TextLink {...rest}>
      <Wrapper className="has-icon">{children}</Wrapper>
    </TextLink>
  ) : (
    <Wrapper>{children}</Wrapper>
  );
